/** Not blank, and not "unknown" or "null" (how upstream sometimes writes a missing value). */
export function isKnown(value: string | null | undefined): value is string {
  if (!value) return false;
  const normalised = value.trim().toLowerCase();
  return normalised !== "" && normalised !== "unknown" && normalised !== "null";
}
